import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
// @ts-nocheck

import { addEvent, _storage } from "../../../utils";
var TimeConsuming = /*#__PURE__*/function () {
  function TimeConsuming(tracert) {
    var _this = this;
    _classCallCheck(this, TimeConsuming);
    /**
     * 暂停时间计算
     * 把已消耗的时间暂存，重置页面开始时间
     */
    _defineProperty(this, "pause", function (ev) {
      if (ev.target === window) {
        _this.paused = true;
        _this._time_consumed += Date.now() - _this._start_timestamp;
      }
    });
    /**
     * 恢复计时
     */
    _defineProperty(this, "resume", function () {
      if (_this.paused) {
        _this._start_timestamp = Date.now();
      }
    });
    /**
     * 意外离开，暂存当前页面耗时信息
     */
    _defineProperty(this, "cache", function () {
      var pageUrl = location.href;
      var timeConsuming = _this.gettimeConsuming();
      _storage.set('residual', "".concat(encodeURIComponent(pageUrl), "|").concat(timeConsuming));
    });
    this._tracert_inst = tracert;
    this.paused = false;
    this.start();
    this.bindEventListeners();
  }
  _createClass(TimeConsuming, [{
    key: "start",
    value: function start() {
      this._start_timestamp = Date.now();
      this._time_consumed = 0;
      this.lastClickEle = null;
      this.lastClickText = '';
    }

    /**
     * 绑定事件
     */
  }, {
    key: "bindEventListeners",
    value: function bindEventListeners() {
      addEvent('blur', window, this.pause);
      addEvent('focus', window, this.resume);
      addEvent('beforeunload', window, this.cache);
    }
  }, {
    key: "gettimeConsuming",
    value:
    /**
     * 获取耗时
     */
    function gettimeConsuming() {
      return this.paused ? this._time_consumed : this._time_consumed + (Date.now() - this._start_timestamp);
    }
  }, {
    key: "getTime",
    value:
    // 从临时存储中获取上个页面的耗时
    function getTime() {
      var residual = _storage.get('residual', {}, true);
      if (!residual) {
        return null;
      }
      var arr = residual.split('|');
      var pageUrl = arr[0];
      var timeConsuming = arr[1];
      try {
        if (decodeURIComponent(pageUrl) === this._tracert_inst.refUrl) {
          return timeConsuming;
        }
      } catch (e) {
        return null;
      }
      return null;
    }
  }]);
  return TimeConsuming;
}();
export { TimeConsuming as default };